module.exports = __webpack_public_path__ + "img/img_jcal.cfb542de.png";